import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
const Navbar=()=>{
    return(
        <div>
            <nav className="Navbar">
                <Link to="/" className="Brand">Portfo<span>lio</span></Link>
                <ul className="Nav-links">
                    <Link to="/" className="Nav-item">Home</Link>
                    <Link to="/Projects" className="Nav-item">Projects</Link>
                    <Link to="/About" className="Nav-item">About</Link>
                    <Link to="/Contact" className="Nav-item">Contact</Link>
                </ul>
            </nav>
        </div>
    );
};
export default Navbar;